<div id="SubscribeBoxModal" class="modal fade success-popup" tabindex="-1" role="dialog" bsModal>
  <div class="custom-theme-modal modal-dialog modal-md modal-dialog-centered">
    <div class="row">
      <div class="col-md-7 p-0">
        <div class="position-relative px-3 px-sm-4 py-sm-5 pb-3 pt-5">
          <a class="back-page position-absolute">
            <img src="./assets/themes/icons/public/cancel.svg" width="20px" />
          </a>
          <h5 class="mb-3 heading-3">Enter OTP</h5>
          <p class="paragraph"><span class="color-grey-700">
              A One-Time Password (OTP) was sent to +91 98493 93393 <img src="./assets/themes/icons/public/edit.svg"
                width="20px" />
            </span></p>
        </div>
      </div>
    </div>
  </div>
</div>